import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GetCourses from "../../actions/GetCourses";
import CourseItem from "./CourseItem";
import CourseItemSkeleton from "./CourseItemSkeleton";
import Localbase from "localbase";
import CoursesSkeleton from "../../components/skeletons/Courses";
import DetectDevice from "../../data/DetectDevice";
// import CourseDesign1 from "./CourseItem";
const CoursesList = ({ mode, limit }) => {
  const [loading, setloading] = useState(true);

  const [useronline, setuseronline] = useState(true);
  const db = new Localbase("db");

  const device = DetectDevice();

  const NewGetCourses = async ({ mode }) => {
    try {
      //setloading(true)
      const res = await GetCourses({
        payload: {
          mode: mode,
          limit: limit || 50,
          device: device === "mobile" ? "mobile" : "desktop",
        },
      });
      if (res) {
        setloading(false);
        setcourses(res);

        db.collection("paths").add({ new_courses: res }, "new_courses");
        if (mode === "offline") {
          db.collection("paths").add(
            {
              offline_courses: res,
            },
            "offline_courses",
          );
        } else if (mode === "specialization") {
          db.collection("paths").add(
            {
              specialization_courses: res,
            },
            "specialization_courses",
          );
        } else if (mode === "live") {
          db.collection("paths").add(
            {
              live_online_courses: res,
            },
            "live_online_courses",
          );
        } else if (mode === "selfpaced") {
          db.collection("paths").add(
            {
              selfpaced_courses: res,
            },
            "selfpaced_courses",
          );
        }

        console.log(res);
      } else {
        console.log("network error");
      }
    } catch (err) {
      setuseronline(false);
      setloading(false);
      console.log("something went wrong");
    }
  };

  var scrollAmount;

  const buttonclick = () => {
    var container = document.getElementById("container" + mode);
    sideScroll(container, "right", 15, 300, 10);
  };

  const back = () => {
    var container = document.getElementById("container" + mode);
    sideScroll(container, "left", 15, 300, 10);
  };

  function sideScroll(element, direction, speed, distance, step) {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === "left") {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  const GetOfflineData = () => {
    console.log("mode is " + mode);
    if (mode === "free") {
      db.collection("paths")
        .doc("free_courses")
        .get()
        .then((data) => {
          setcourses(data.free_courses);
          setloading(false);
        })
        .catch((error) => { });
    }
    if (mode === "offline") {
      db.collection("paths")
        .doc("offline_courses")
        .get()
        .then((data) => {
          console.log(data);
          setcourses(data.offline_courses);
          setloading(false);
        })
        .catch((error) => { });
    }
    if (mode === "selfpaced") {
      db.collection("paths")
        .doc("selfpaced_courses")
        .get()
        .then((data) => {
          setcourses(data.selfpaced_courses);
          setloading(false);
        })
        .catch((error) => { });
    }
    if (mode === "live") {
      db.collection("paths")
        .doc("live_online_courses")
        .get()
        .then((data) => {
          setcourses(data.live_online_courses);
          setloading(false);
        })
        .catch((error) => { });
    }
    if (mode === "specialization") {
      db.collection("paths")
        .doc("specialization_courses")
        .get()
        .then((data) => {
          console.log("data stored is " + data.specialization_courses);
          setcourses(data.specialization_courses);
        })
        .catch((error) => {
          console.log("data error");
        });
    }

    setloading(false);
  };
  useEffect(() => {
    GetOfflineData();
  }, [window.location, courses, mode]);

  useEffect(() => {
    NewGetCourses({ mode }).catch(() => {
      NewGetCourses({ mode });
    });
  }, []);

  const [courses, setcourses] = useState(null);
  return (
    <>
      <div className="w-100 d-flex flex-wrap">
        {loading ? (
          <>
            <div className=" mt-3 mb-3 container">
              <CoursesSkeleton />
            </div>
          </>
        ) : (
          <>
            <div className="d-flex animation-active flex-wrap w-100">
              {Array.isArray(courses) && courses.length > 0 ? (
                <>
                {/* |<CourseDesign1/> */}
                  {courses.map((course, index) => (
                    <CourseItem
                      key={course.id || index}
                      useronline={useronline}
                      course={course}
                      index={index + 1}
                    />
                  ))}
                </>
              ) : (
                <div className="w-100 d-flex flex-column mx-auto align-items-center justify-content-center mt-5 mb-5">
                  <div className="d-flex flex-column align-items-center justify-content-center text-center mx-auto">
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
                      alt="No courses available"
                      style={{ width: 120, height: 120, marginBottom: 16, opacity: 0.7 }}
                    />
                    <h5 className="text-muted">No courses available now</h5>
                    <p className="text-secondary">Please check back later for new courses.</p>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div><style>{`
      /* =========================
   COURSE CARD
========================= */
.ly-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(0,0,0,.08);
  overflow: hidden;
  transition: transform .25s ease;
}

.ly-card:hover {
  transform: translateY(-6px);
}

/* =========================
   IMAGE CONTAINER
========================= */
.ly-img {
  position: relative;
  height: 200px;
  margin: 14px;              /* 🔥 SPACE BETWEEN IMAGE & CARD */
  border-radius: 14px;       /* 🔥 IMAGE ONLY ROUNDED */
  overflow: hidden;
  background: #000;
}

/* Blurred background fill */
.ly-img::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: var(--bg);
  background-size: cover;
  background-position: center;
  filter: blur(16px);
  transform: scale(1.15);
  opacity: 0.35;
  z-index: 0;
}

/* Actual image */
.ly-img img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;      /* NO CROPPING */
  z-index: 1;
}

/* =========================
   LIVE / SELF BADGE
========================= */
.ly-badge {
  position: absolute;
  bottom: 12px;
  left: 12px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 999px;
  color: #fff;
  z-index: 2;
}

.ly-badge.live {
  background: #ef4444;
}

.ly-badge.self {
  background: #1e40af;
}

/* =========================
   CARD BODY
========================= */
.ly-body {
  padding: 16px 18px 18px;
}

.ly-title {
  font-size: 17px;
  font-weight: 600;
  margin: 8px 0;
  color: #111827;
}

.ly-enrolled {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 10px;
}

.ly-price-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.ly-price {
  font-size: 18px;
  font-weight: 700;
  color: #15803d;
}

.ly-price-row del {
  color: #9ca3af;
}

.ly-seats {
  margin-left: auto;
  font-size: 14px;
  color: #dc2626;
}

/* =========================
   BUTTON
========================= */
.ly-btn {
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: none;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.ly-btn:hover {
  opacity: .9;
}

/* =========================
   MOBILE
========================= */
@media (max-width: 576px) {
  .ly-img {
    height: 180px;
    margin: 12px;
  }
}

      `}</style>
    </>
  );
};

export default CoursesList;
